import _round from 'lodash/round';

/**
 * @memberof Shop
 * @class
 * @alias Shop.money
 *
 * @description
 * Класс для работы с валютой.
 */
var Money = function(_owner) {
  var self = this;

  self.options = self._getOptions(_owner);
};

/**
 * Инициалиация
 * @method
 * @private
 *
 * @todo
 * Получить json для автоматического получения настроек, и сделать их автоматическое применение
 */
Money.prototype._getOptions = function(_owner) {
  var self = this;

  return _owner.config
    .get('money_with_currency_format')
    .money_with_currency_format;
};

/**
 * @method
 * @deprecated
 *
 * @param {Object} params - Объект с настройками валюты, в ликвид '{{ money_with_currency_format }}'
 *
 * @description
 * Вызов применения настроек
 * ВАЖНО!! теперь информация получается автоматически при загрузки страницы. Более не требуется происзодить данную операцию.
 */
Money.prototype.set = function(params) {
  var self = this;

  console.warn('Shop.money.set() is deprecated!!! InSales JS API get money format automatically');

  return;
};

/**
 * Форматирование входной строки к виду, согласно настройкам БО
 * @method
 *
 * @param {string|number} amount - строка или число, которое надо отформатировать в валюту
 *
 * @return {string} Строка, содержащая результат форматирования
 *
 * @example
 * Shop.money.format(1234.00);
 */
Money.prototype.format = function(amount, formatRouble) {
  var self = this;
  var value = amount;
  var patern = /(\d)(?=(\d\d\d)+(?!\d))/g;

  if (amount === null || amount === undefined) {
    return '';
  }

  if (self.options.delimiter != '.') {
    value = value.toString().replace(',', '.').replace(self.options.delimiter, '');
  } else {
    value = value.toString().replace(',', '.');
  }

  value = (formatRouble === null || formatRouble === undefined) ? parseFloat(value).toFixed(2) : parseFloat(value).toFixed(0);
  value = value.toString().split('.');

  if (self.options.show_price_without_cents) {
    for (var i = 0; i < value.length; i++) {
      if (self.options.delimiter != '.') {
        value[i] = value[i].replace(self.options.delimiter, '');
      }
    }
    var num = value.join('.');

    var result = _round(num);
    value = result.toString().replace(patern, '$1' + self.options.delimiter);
  } else {
    value[0] = value[0].replace(patern, '$1' + self.options.delimiter);
    var result = value.join(self.options.separator);
    value = result;
  }

  if (formatRouble === null || formatRouble === undefined) {
    value = self.options.format.replace('%n', value).replace('%u', self.options.unit);
  }
  else {
    value = self.options.format.replace('%n', value).replace('%u', '&#8381');
  }


  return value;
};

export default Money;
